// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__FNOLWCWizard__FNOLWCWizardContainer div[class*=wizardMain]{--gw-wizard-page-main-width:100%}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-fnol-wc-react/FNOLWCWizard.module.scss"],"names":[],"mappings":"AACM,iEACM,gCAAA","sourcesContent":[".FNOLWCWizardContainer {\n      div[class*='wizardMain'] {\n            --gw-wizard-page-main-width: 100%;\n      }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FNOLWCWizardContainer": "app__FNOLWCWizard__FNOLWCWizardContainer"
};
export default ___CSS_LOADER_EXPORT___;
